import React, { useState, useContext } from "react";
import { Redirect } from "react-router-dom";
import PageLayout from "components/layouts/PageLayout";
import { Button } from "components/common";
import EmployeeCode from "lib/api/EmployeeCode";
import { UserContext } from "lib/context/UserContext";

const SERVICE_TYPES = {
  CATALOG: "catalog",
  TIMESHEET: "timesheet",
  IDENTITY: "identity"
};

export default function RenameEmployeesForm() {
  const { user } = useContext(UserContext); 
  const [input, setInput] = useState("");
  const [service, setService] = useState(SERVICE_TYPES.TIMESHEET);
  const [processing, setProcessing] = useState(false);
  const [results, setResults] = useState([]);
  
  if (user?.email !== "johnwelch@deltek.com") {
    return <Redirect to="/clients" />;
  }

  function parseLines(value) {
    const rows = value
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter(Boolean);
    if (rows.length === 0) return [];

    const headerMatch = /^CompanyId\t.*Employee/i.test(rows[0]);
    const dataRows = headerMatch ? rows.slice(1) : rows;

    return dataRows.map((l) => {
      const [company_uuid, old_code, new_code] = l.split("\t");
      return { company_uuid, old_code, new_code };
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const records = parseLines(input);
    if (records.length === 0) {
      alert("No valid rows found.");
      return;
    }

    setProcessing(true);
    setResults([]);

    const outcomes = [];

    for (const rec of records) {
      try {
        if (service === SERVICE_TYPES.TIMESHEET) {
          const res = await EmployeeCode.updateTimesheet({
            employee_code: rec.old_code,
            new_employee_code: rec.new_code,
            company_uuid: rec.company_uuid,
          });
          const outcome = { ...rec, success: true, rowsAffected: res.rowsAffected };
          outcomes.push(outcome);
          setResults([...outcomes]);
        } else if (service === SERVICE_TYPES.CATALOG) {
          const res = await EmployeeCode.updateCatalog({
            oldCode: rec.old_code,
            newCode: rec.new_code,
            company_uuid: rec.company_uuid,
          });
          const outcome = { ...rec, success: true, rowsAffected: res.rowsAffected };
          outcomes.push(outcome);
          setResults([...outcomes]);
        }
        else if (service === SERVICE_TYPES.IDENTITY) {
          const res = await EmployeeCode.updateIdentity({
            company_uuid: rec.company_uuid,
            employee_code: rec.old_code,
            new_employee_code: rec.new_code
          });
          const outcome = { ...rec, success: true, rowsAffected: res.rowsAffected };
          outcomes.push(outcome);
          setResults([...outcomes]);
        }
      } catch (err) {
        const outcome = {
          ...rec,
          success: false,
          error: err.message || "Request failed",
        };
        outcomes.push(outcome);
        setResults([...outcomes]);
      }
    }

    setProcessing(false);
  }

  function renderResults() {
    if (results.length === 0) return null;
    return (
      <>
        <h2 className="m-top-20">Results</h2>
        <table className="table table--bordered">
          <thead>
            <tr>
              <th>Company UUID</th>
              <th>Old Code</th>
              <th>New Code</th>
              <th>Status</th>
              <th>Rows&nbsp;Updated</th>
              <th>Error&nbsp;Message</th>
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => (
              <tr key={i}>
                <td>{r.company_uuid}</td>
                <td>{r.old_code}</td>
                <td>{r.new_code}</td>
                <td>{r.success ? "✓" : "✗"}</td>
                <td>{r.rowsAffected ? r.rowsAffected.total : ""}</td>
                <td>{r.success ? "" : r.error}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    );
  }

  return (
    <PageLayout>
      <h1>Rename Employees</h1>
      <div className="hr hr--darkest"></div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xs-12">
            <label className="label__span">Tab‑Delimited Input</label>
            <textarea
              className="textarea textarea--full"
              rows="10"
              placeholder={`CompanyId\tOld Employee #\tNew Employee #\n5153da0b-159e-4d24-b72e-a52484d6fd92\tASTO J\t10156817`}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="row m-top-10">
          <div className="col-xs-12">
            <label className="label__span">Service</label>
            <div className="button-group">
              <label className="button button--plain m-left-10">
                <input
                  type="radio"
                  name="service"
                  value={SERVICE_TYPES.IDENTITY}
                  checked={service === SERVICE_TYPES.IDENTITY}
                  onChange={() => setService(SERVICE_TYPES.IDENTITY)}
                />
                Identity&nbsp;Service
              </label>
              <label className="button button--plain m-right-10">
                <input
                  type="radio"
                  name="service"
                  value={SERVICE_TYPES.TIMESHEET}
                  checked={service === SERVICE_TYPES.TIMESHEET}
                  onChange={() => setService(SERVICE_TYPES.TIMESHEET)}
                />
                Timesheet&nbsp;Service
              </label>
              <label className="button button--plain">
                <input
                  type="radio"
                  name="service"
                  value={SERVICE_TYPES.CATALOG}
                  checked={service === SERVICE_TYPES.CATALOG}
                  onChange={() => setService(SERVICE_TYPES.CATALOG)}
                />
                Catalog&nbsp;Service
              </label>
            </div>
          </div>
        </div>

        <div className="row m-top-20">
          <div className="col-xs-12">
            <Button
              type="submit"
              className="button button--primary"
              disabled={processing}
            >
              {processing ? "Processing…" : "Submit"}
            </Button>
          </div>
        </div>
      </form>

      {renderResults()}
    </PageLayout>
  );
}
